/** Keep in sync with ../../../config/productVectors.js */
export const CURRENT_INTEREST_BANK_VERSION = 'v2';

/** Legacy single-round attempt size; tri-group also uses 80 and 120 cumulatively. */
export const INTEREST_VECTOR_LENGTH = 40;
export const INTEREST_BANK_SIZE = 120;

export const INTEREST_TRI_GROUP_SCORING_SIZES = Object.freeze([40, 80, 120]);

/**
 * @param {number} length
 * @returns {boolean}
 */
export function isScoreableInterestVectorLength(length) {
  return INTEREST_TRI_GROUP_SCORING_SIZES.includes(length);
}
